<template>
     <el-container>
                <!-- 头部 -->
        <div class="indeherader">
          <el-header class="flex nsherader">  
               <MangeHeader />
           </el-header>
        </div>
           <div class="isSilderMenu"  @click="openBz" v-if="$route.path !='/myExam/transcriptExam'">
           <el-tooltip class="item" effect="dark" content="帮助文档" placement="left">
           <span class="icon-al-question-circle"></span>   
          </el-tooltip>
     
          </div>
             <div class="sidebar" v-if="!isSpecialPath">
             <examSidebar />
            
        </div>
         <el-main class="indemain" :class="!isSpecialPath ? 'indemain' : 'indemain1'">
            <transition name="slide">
              <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view> 
          </keep-alive>
            </transition>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
        </el-main>
     </el-container>
</template>
<script>
    import MangeHeader from "./components/MangeHeader"
     import examSidebar from "./components/examSidebar"
    import { dowloadDetail} from "@/api/enterprise/index" // 下载详情、线索、
export default {
     name: "Layout",
    inject: ["reload"],
     components: {
        MangeHeader,
        examSidebar
      },
    data () {
        return {
          appID:''
        }
    },
     computed: {
    isSpecialPath() {
      const specialPaths = [
        '/myExam/examLogin',
        '/myExam/doExam',
        '/myExam/transcriptExam',
        '/myExam/practiceExam'
      ];
      return specialPaths.includes(this.$route.path);
    }
  },
    created() {
         this.appID = this.$locaStorage.setAge().get('doExamHelpId')
    },
    methods: {
         // 打开对应帮助文档
            openBz(){
                dowloadDetail({
                id:this.appID,
            },'enterprise')
            .then(res => {
              if(res.data){
                const newurl = this.$router.resolve({name: 'enhelpdetail', query: {id: res.data.supportId,type:1}})
                window.open(newurl.href,'_blank')
              }else{
                this.$util.Notifi(err.msg,'error','fa-exclamation-circle');
              }
            })
            .catch(err => {
                this.$util.Notifi(err.msg,'error','fa-exclamation-circle');
            })
                
            },
    },
}
</script>
<style lang="scss" scoped>
.isSilderMenu{
    position: fixed;
        bottom: 10%;
        right: 40px;
        z-index: 999;
        cursor: pointer;
      span{
          font-size:  30px
      }
}
.sidebar{
    width: 300px;
    background:  #f5f6fa;;
    height: calc(100vh - 57px);
    position: fixed;
    left: 0px;
    top: 57px;
    box-sizing: border-box;
    z-index: 99;
}
.indemain{
 width: calc(100% - 300px);
    height: 100vh;
    position: fixed;
    left: 300px;
    top: 57px;
    background: rgb(245, 246, 250);
    overflow-y: auto;
    padding-bottom: 50px;
}
.indemain::-webkit-scrollbar {
    display: none;
}
.indemain1{
  left: 0;
  width: 100%;
}
     .sider-head{
            width: 120px;
            height: 40px;
        }
        ::v-deep{
    .sidebar{
        .el-menu{background: none !important;border: none !important;}
.el-submenu,.el-menu-item,.el-submenu__title,.el-menu-item [class^=el-icon-],.el-submenu [class^=el-icon-] {
  color: #fff;
}
.el-submenu__title i {
    color: #fff;
    padding-right: 20px;
}
.el-menu-item:hover,.el-submenu__title:hover{
    outline: 0;
    background-color: #263445 !important;

}
.el-menu-item:focus,.el-submenu__title:focus{
    outline: 0;
    background-color: #263445 !important;

}
    }
}
</style>
